import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "otherMessages" }
const _hoisted_2 = { class: "otherMessages" }
const _hoisted_3 = { class: "myMessageEdit" }
const _hoisted_4 = { class: "otherMessages" }
const _hoisted_5 = { class: "myMessageEdit" }
const _hoisted_6 = { class: "otherMessages" }
const _hoisted_7 = { class: "myMessageEdit" }
const _hoisted_8 = { class: "otherMessages" }
const _hoisted_9 = { class: "myMessageEdit" }
const _hoisted_10 = { class: "otherMessages" }
const _hoisted_11 = { class: "myMessageEdit" }
const _hoisted_12 = { class: "otherMessages" }
const _hoisted_13 = { class: "myMessageEdit" }
const _hoisted_14 = { class: "otherMessages" }
const _hoisted_15 = { class: "myMessageEdit" }
const _hoisted_16 = { class: "otherMessages" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn_prev = _resolveComponent("v-btn-prev")!
  const _component_v_flex = _resolveComponent("v-flex")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_oss_text_field_filled = _resolveComponent("oss-text-field-filled")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_date_picker_wrapper = _resolveComponent("v-date-picker-wrapper")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_CompaniesTable = _resolveComponent("CompaniesTable")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_layout = _resolveComponent("v-layout")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_DocumentWizardDialog = _resolveComponent("DocumentWizardDialog")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_btn_next = _resolveComponent("v-btn-next")!

  return (_openBlock(), _createBlock(_component_v_layout, {
    fluid: "",
    style: {"padding":"0px"},
    class: "d-flex align-content-space-between flex-wrap"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_flex, { xs12: "" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_btn_prev, {
            size: "small",
            color: "ternary",
            disabled: _ctx.previousStep === -1,
            elevation: "0",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.step = _ctx.previousStep))
          }, null, 8, ["disabled"])
        ]),
        _: 1
      }),
      _createVNode(_component_v_flex, { xs12: "" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_window, {
            modelValue: _ctx.step,
            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.step) = $event))
          }, {
            default: _withCtx(() => [
              (_ctx.vatRateIsMissing)
                ? (_openBlock(), _createBlock(_component_v_window_item, {
                    key: 0,
                    value: 0
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_container, null, {
                        default: _withCtx(() => [
                          _createElementVNode("small", null, [
                            _createElementVNode("b", null, _toDisplayString(_ctx.getQuestion("VAT_RATE").sender.firstname +
                                " " +
                                _ctx.getQuestion("VAT_RATE").sender.lastname +
                                " . "), 1),
                            _createTextVNode(" " + _toDisplayString(_ctx.getDate(_ctx.getQuestion("VAT_RATE").createdAt)), 1)
                          ]),
                          _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.getQuestion("VAT_RATE").text), 1),
                          _createVNode(_component_v_list, {
                            subheader: "",
                            style: {"overflow":"scroll"},
                            class: "myMessages mt-2",
                            lines: "two"
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.vatRates, (vat, i) => {
                                return (_openBlock(), _createBlock(_component_v_list_item, {
                                  key: i,
                                  onClick: ($event: any) => (_ctx.selectVat(vat)),
                                  class: "mx-1 my-2 py-0",
                                  style: {"background":"#fff","min-height":"min-content !important"}
                                }, {
                                  append: _withCtx(() => [
                                    _createVNode(_component_v_btn, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_icon, { color: "primary" }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(vat === _ctx.document.vatRate
                                                ? "$radio_button_checked"
                                                : "$radio_button_unchecked"), 1)
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_list_item_title, null, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(vat) + "% ", 1)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"]))
                              }), 128))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.vatAmountIsMissing)
                ? (_openBlock(), _createBlock(_component_v_window_item, {
                    key: 1,
                    value: 1
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_container, null, {
                        default: _withCtx(() => [
                          _createElementVNode("small", null, [
                            _createElementVNode("b", null, _toDisplayString(_ctx.getQuestion("VAT_AMOUNT").sender.firstname +
                                " " +
                                _ctx.getQuestion("VAT_AMOUNT").sender.lastname +
                                " . "), 1),
                            _createTextVNode(" " + _toDisplayString(_ctx.getDate(_ctx.getQuestion("VAT_AMOUNT").createdAt)), 1)
                          ]),
                          _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.getQuestion("VAT_AMOUNT").text), 1),
                          _createVNode(_component_v_divider, { class: "my-2" }),
                          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("chat.smartAsk.defaultAnswers.vatAmount", {
                                    value: _ctx.newCommonFormatCurrency(_ctx.document.vatAmount, undefined),
                                })), 1),
                          _createVNode(_component_oss_text_field_filled, {
                            label: "Montant de la TVA",
                            min: "0",
                            "content-class": "mx-1 my-2",
                            "mx-1": "",
                            outlined: "",
                            modelValue: _ctx.document.vatAmount,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.document.vatAmount) = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.grossAmountIsMissing)
                ? (_openBlock(), _createBlock(_component_v_window_item, {
                    key: 2,
                    value: 2
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_container, null, {
                        default: _withCtx(() => [
                          _createElementVNode("small", null, [
                            _createElementVNode("b", null, _toDisplayString(_ctx.getQuestion("HT").sender.firstname +
                                " " +
                                _ctx.getQuestion("HT").sender.lastname +
                                " . "), 1),
                            _createTextVNode(" " + _toDisplayString(_ctx.getDate(_ctx.getQuestion("HT").createdAt)), 1)
                          ]),
                          _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.getQuestion("HT").text), 1),
                          _createVNode(_component_v_divider, { class: "my-2" }),
                          _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t("chat.smartAsk.defaultAnswers.grossAmount", {
                                    value: _ctx.newCommonFormatCurrency(_ctx.document.grossAmount, undefined),
                                })), 1),
                          _createVNode(_component_oss_text_field_filled, {
                            label: "Montant HT",
                            min: "0",
                            "content-class": "mx-1",
                            outlined: "",
                            modelValue: _ctx.document.grossAmount,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.document.grossAmount) = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.netAmountIsMissing)
                ? (_openBlock(), _createBlock(_component_v_window_item, {
                    key: 3,
                    value: 3
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_container, null, {
                        default: _withCtx(() => [
                          _createElementVNode("small", null, [
                            _createElementVNode("b", null, _toDisplayString(_ctx.getQuestion("TTC").sender.firstname +
                                " " +
                                _ctx.getQuestion("TTC").sender.lastname +
                                " . "), 1),
                            _createTextVNode(" " + _toDisplayString(_ctx.getDate(_ctx.getQuestion("TTC").createdAt)), 1)
                          ]),
                          _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.getQuestion("TTC").text), 1),
                          _createVNode(_component_v_divider, { class: "my-2" }),
                          _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t("chat.smartAsk.defaultAnswers.netAmount", {
                                    value: _ctx.newCommonFormatCurrency(_ctx.document.netAmount, undefined),
                                })), 1),
                          _createVNode(_component_oss_text_field_filled, {
                            label: "Montant TTC",
                            min: "0",
                            "content-class": "mx-1",
                            outlined: "",
                            modelValue: _ctx.document.netAmount,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.document.netAmount) = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_v_window_item, { value: 4 }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_container, {
                    fluid: "",
                    class: "d-flex align-center"
                  }, {
                    default: _withCtx(() => [
                      _cache[20] || (_cache[20] = _createTextVNode(" Le numero de facture est ")),
                      _createElementVNode("span", null, [
                        _createVNode(_component_v_text_field, {
                          modelValue: _ctx.document.invoiceNumber,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.document.invoiceNumber) = $event)),
                          class: "mx-1",
                          outlined: ""
                        }, null, 8, ["modelValue"])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              (_ctx.thirdPartyIsMissing)
                ? (_openBlock(), _createBlock(_component_v_window_item, {
                    key: 4,
                    value: 4
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_container, null, {
                        default: _withCtx(() => [
                          _createElementVNode("small", null, [
                            _createElementVNode("b", null, _toDisplayString(_ctx.getQuestion("THIRD_PARTY_COMPANY").sender.firstname +
                                " " +
                                _ctx.getQuestion("THIRD_PARTY_COMPANY").sender.lastname +
                                " . "), 1),
                            _createTextVNode(" " + _toDisplayString(_ctx.getDate(_ctx.getQuestion("THIRD_PARTY_COMPANY").createdAt)), 1)
                          ]),
                          _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.getQuestion("THIRD_PARTY_COMPANY").text), 1),
                          _createVNode(_component_v_divider, { class: "my-2" }),
                          _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t("chat.smartAsk.defaultAnswers.thirdParty", {
                                    value: _ctx.document.thirdParty.name,
                                })), 1),
                          _createVNode(_component_v_flex, {
                            "my-4": "",
                            class: "d-flex justify-center"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_btn, {
                                elevation: "0",
                                rounded: "",
                                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.activeSelectCompany = true))
                              }, {
                                default: _withCtx(() => _cache[21] || (_cache[21] = [
                                  _createTextVNode(" Sélectionner une société ")
                                ])),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_dialog, {
                        modelValue: _ctx.activeSelectCompany,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.activeSelectCompany) = $event)),
                        fullscreen: _ctx.$vuetify.display.mobile
                      }, {
                        activator: _withCtx(({ props }) => [
                          _createVNode(_component_v_date_picker_wrapper, {
                            label: "Date d'échéance",
                            modelValue: _ctx.dueDate,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.dueDate) = $event)),
                            class: "mt-4",
                            width: "auto",
                            color: "secondary",
                            "hide-header": "",
                            "show-current": false
                          }, null, 8, ["modelValue"])
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_v_card, {
                            class: "default_card pa-2",
                            "max-width": "70%",
                            style: {"margin":"auto"}
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_card_title, { class: "headline" }, {
                                default: _withCtx(() => _cache[22] || (_cache[22] = [
                                  _createTextVNode("Choisir la société ters")
                                ])),
                                _: 1
                              }),
                              _createVNode(_component_v_card_text, { style: {"overflow-y":"auto","height":"65vh"} }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_CompaniesTable, {
                                    showGenericCompany: false,
                                    showConsumerCompanies: true,
                                    showCustomerCompanies: true,
                                    showExistingCompanies: false,
                                    company: 
                                        _ctx.document.thirdParty.name ? _ctx.document.thirdParty.name : ''
                                    ,
                                    siret: 
                                        _ctx.document.thirdParty.siret ? _ctx.document.thirdParty.siret : ''
                                    ,
                                    siren: 
                                        _ctx.document.thirdParty.siren ? _ctx.document.thirdParty.siren : ''
                                    ,
                                    vatNumber: 
                                        _ctx.document.thirdParty.vatNumber
                                            ? _ctx.document.thirdParty.vatNumber
                                            : ''
                                    ,
                                    parentCompanyId: _ctx.companyId,
                                    wizardMode: true,
                                    onSelectCompany: _cache[7] || (_cache[7] = ($event: any) => (_ctx.setThirdParty($event)))
                                  }, null, 8, ["company", "siret", "siren", "vatNumber", "parentCompanyId"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_card_actions, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_layout, { wrap: "" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_flex, {
                                        xs12: "",
                                        "mr-5": "",
                                        class: "d-flex justify-end"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_btn, {
                                            rounded: "",
                                            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.activeSelectCompany = false)),
                                            size: "small"
                                          }, {
                                            default: _withCtx(() => _cache[23] || (_cache[23] = [
                                              _createTextVNode("Annuler")
                                            ])),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue", "fullscreen"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.dateIsMissing)
                ? (_openBlock(), _createBlock(_component_v_window_item, {
                    key: 5,
                    value: 5
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_container, null, {
                        default: _withCtx(() => [
                          _createElementVNode("small", null, [
                            _createElementVNode("b", null, _toDisplayString(_ctx.getQuestion("DATE").sender.firstname +
                                " " +
                                _ctx.getQuestion("DATE").sender.lastname +
                                " . "), 1),
                            _createTextVNode(" " + _toDisplayString(_ctx.getDate(_ctx.getQuestion("DATE").createdAt)), 1)
                          ]),
                          _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.getQuestion("DATE").text), 1),
                          _createVNode(_component_v_divider, { class: "my-2" }),
                          _createElementVNode("div", _hoisted_11, [
                            _createVNode(_component_v_date_picker_wrapper, {
                              modelValue: _ctx.date,
                              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.date) = $event)),
                              class: "mt-4",
                              width: "auto",
                              color: "secondary",
                              "hide-header": "",
                              "show-current": false
                            }, null, 8, ["modelValue"])
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.dueDateIsMissing)
                ? (_openBlock(), _createBlock(_component_v_window_item, {
                    key: 6,
                    value: 6
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_container, null, {
                        default: _withCtx(() => [
                          _createElementVNode("small", null, [
                            _createElementVNode("b", null, _toDisplayString(_ctx.getQuestion("DUE_DATE").sender.firstname +
                                " " +
                                _ctx.getQuestion("DUE_DATE").sender.lastname +
                                " . "), 1),
                            _createTextVNode(" " + _toDisplayString(_ctx.getDate(_ctx.getQuestion("DUE_DATE").createdAt)), 1)
                          ]),
                          _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.getQuestion("DUE_DATE").text), 1),
                          _createVNode(_component_v_divider, { class: "my-2" }),
                          _createElementVNode("div", _hoisted_13, [
                            _createVNode(_component_v_date_picker_wrapper, {
                              modelValue: _ctx.dueDate,
                              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.dueDate) = $event)),
                              class: "mt-4",
                              width: "auto",
                              color: "secondary",
                              "hide-header": "",
                              "show-current": false
                            }, null, 8, ["modelValue"])
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.invoiceNumberIsMissing)
                ? (_openBlock(), _createBlock(_component_v_window_item, {
                    key: 7,
                    value: 7
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_container, null, {
                        default: _withCtx(() => [
                          _createElementVNode("small", null, [
                            _createElementVNode("b", null, _toDisplayString(_ctx.getQuestion("INVOICE_NUMBER").sender.firstname +
                                " " +
                                _ctx.getQuestion("INVOICE_NUMBER").sender.lastname +
                                " . "), 1),
                            _createTextVNode(" " + _toDisplayString(_ctx.getDate(_ctx.getQuestion("INVOICE_NUMBER").createdAt)), 1)
                          ]),
                          _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.getQuestion("INVOICE_NUMBER").text), 1),
                          _createVNode(_component_v_divider, { class: "my-2" }),
                          _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$t("chat.smartAsk.defaultAnswers.invoiceNumber", {
                                    text: _ctx.document.invoiceNumber,
                                })), 1),
                          _createVNode(_component_v_text_field, {
                            modelValue: _ctx.document.invoiceNumber,
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.document.invoiceNumber) = $event)),
                            label: "Numéro de facture",
                            rounded: ""
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.lowQualityIsMissing)
                ? (_openBlock(), _createBlock(_component_v_window_item, {
                    key: 8,
                    value: 8
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_container, null, {
                        default: _withCtx(() => [
                          _createElementVNode("small", null, [
                            _createElementVNode("b", null, _toDisplayString(_ctx.getQuestion("LOW_QUALITY").sender.firstname +
                                " " +
                                _ctx.getQuestion("LOW_QUALITY").sender.lastname +
                                " . "), 1),
                            _createTextVNode(" " + _toDisplayString(_ctx.getDate(_ctx.getQuestion("LOW_QUALITY").createdAt)), 1)
                          ]),
                          _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.getQuestion("LOW_QUALITY").text), 1),
                          _createVNode(_component_v_flex, {
                            xs12: "",
                            "my-2": "",
                            class: "d-flex align-center justify-center"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_btn, {
                                disabled: _ctx.reuploaded,
                                elevation: "0",
                                rounded: "",
                                dense: "",
                                onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.activeUploadDocument = true))
                              }, {
                                default: _withCtx(() => _cache[24] || (_cache[24] = [
                                  _createTextVNode(" Réimporter le fichier ")
                                ])),
                                _: 1
                              }, 8, ["disabled"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_DocumentWizardDialog, {
                            active: _ctx.activeUploadDocument,
                            "onUpdate:active": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.activeUploadDocument) = $event)),
                            companyId: _ctx.companyId,
                            documentId: _ctx.documentInfo.id,
                            documentType: _ctx.documentInfo.type,
                            showFirstPrevious: false,
                            multiple: false,
                            onFileUploaded: _cache[15] || (_cache[15] = ($event: any) => (_ctx.onFileUploaded()))
                          }, null, 8, ["active", "companyId", "documentId", "documentType"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_v_divider),
      _createVNode(_component_v_flex, {
        xs4: "",
        class: "d-flex justify-start"
      }),
      _createVNode(_component_v_flex, {
        xs4: "",
        class: "d-flex justify-center"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_btn_icon, {
            icon: " $fa-comments",
            size: "small",
            color: "primary",
            dark: "",
            elevation: "0",
            onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.reduce()))
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_flex, {
        xs4: "",
        class: "d-flex justify-end"
      }, {
        default: _withCtx(() => [
          (_ctx.nextStep !== -1)
            ? (_openBlock(), _createBlock(_component_v_btn_next, {
                key: 0,
                size: "small",
                color: "primary",
                dark: "",
                elevation: "0",
                onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.step = _ctx.nextStep))
              }))
            : (_openBlock(), _createBlock(_component_v_btn_icon, {
                key: 1,
                icon: "$check",
                size: "small",
                color: "primary",
                dark: !_ctx.disabledCheck,
                elevation: "0",
                loading: _ctx.loadingSend,
                disabled: _ctx.disabledCheck,
                onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.sendResponses()))
              }, null, 8, ["dark", "loading", "disabled"]))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}